import classes from "./contact.module.css";
import ContactIntro from "./contactIntro";
import SocialLinks from "./socialLinks";

const ContactLayout = () => {
  return (
    <>
      <div className={classes.contactContainer}>
        <div className={classes.ContactIntroContainer}>
          <ContactIntro />
        </div>
        <div className={classes.LinksSection}>
          <SocialLinks />
        </div>
      </div>
    </>
  );
};

export default ContactLayout;
